let els;

const scale = function () {
    for (let i = 0; i < els.length; i += 1) {
        const width = els[i].getAttribute("width");
        const height = els[i].getAttribute("height");
        const ratio = width / height;
        let parentWidth = els[i].parentElement.offsetWidth;
        if (els[i].parentNode.getAttribute("data-width-factor") != undefined) {
            parentWidth =
                parentWidth *
                els[i].parentNode.getAttribute("data-width-factor");
        }
        els[i].style.width = `${parentWidth}px`;
        els[i].style.height = `${parentWidth / ratio}px`;
        if (els[i].getAttribute("src").indexOf("youtube") > -1) {
            els[i].setAttribute(
                "src",
                els[i].getAttribute("src") + "?enablejsapi=1"
            );
        }
    }
};
export const iframe = function (el) {
    els = el.querySelectorAll("iframe");
    scale();
    window.addEventListener("resize", scale);
};

let player;

window.onYouTubeIframeAPIReady = function () {
    console.log("onYouTubeIframeAPIReady");
    els = document.querySelectorAll("iframe").forEach(function (theEl, i) {
        if (theEl.getAttribute("src").indexOf("youtube") > -1) {
            theEl.setAttribute("id", `video-${i}`);
            player = new YT.Player(`video-${i}`, {
                events: {
                    // eslint-disable-next-line no-use-before-define
                    onStateChange: function (event) {
                        console.log("onPlayerStateChange", theEl, event);
                        if (event.data == YT.PlayerState.PLAYING) {
                            console.log(event, "playing");
                            theEl.parentNode.classList.add("playing");
                        } else {
                            console.log(event, "not playing");
                            theEl.parentNode.classList.remove("playing");
                        }
                    },
                },
            });
        } else {
            console.log(theEl, "is not a YT video");
        }
    });
};
